'use client';

import React from 'react';
import styled from '@benzinga/themetron';

type OmittedInputElement = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'>;
export interface CheckboxProps extends Partial<OmittedInputElement> {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  label?: string;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, disabled = false, label, onChange, value, ...props }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  const id = `core-checkbox-${props.id || label?.toString()}`;

  return (
    <Container className="checkbox-container">
      <input
        {...props}
        checked={checked}
        className="core-checkbox"
        disabled={disabled}
        id={id}
        onChange={handleChange}
        type="checkbox"
        value={value}
      />
      {label && <label htmlFor={id}>{label}</label>}
    </Container>
  );
};

export default Checkbox;

const Container = styled.div`
  &.checkbox-container {
    display: flex;
    align-items: center;

    .core-checkbox,
    label {
      cursor: pointer;
    }

    label {
      margin-left: 0.5rem;
      font-size: ${({ theme }) => theme.fontSize.base};
    }
    input[type='checkbox'] {
      width: 16px;
      height: 16px;
      border: 1px solid ${({ theme }) => theme.colorPalette.gray300};
      border-radius: ${({ theme }) => theme.borderRadius.default};
      outline: none;
      //appearance: none;

      &:disabled {
        background-color: #b9b9b9;
        border-color: #878787;
        color: #000000d9;
        cursor: not-allowed;
      }
    }
  }
`;
